<template>
  <div>
    <span
      v-if="canShowReviewBadge"
      class="stamped-product-reviews-badge stamped-main-badge"
      :data-id="productId"
      :data-product-type="productType"
      :data-product-title="productName"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'ReviewsBadge',
  props: {
    productId: {
      type: Number,
      required: true,
    },
    productType: {
      type: String,
      default: null,
    },
    productName: {
      type: String,
      default: null,
    },
  },
  computed: {
    canShowReviewBadge() {
      return !!(this.productId && this.productType)
    },
  },
}
</script>
